module.exports = __webpack_public_path__ + "img/notfound.ef9c9531.svg";